import { SortingState } from '@tanstack/react-table'
import { useState } from 'react'
import { GridColDefPro } from '../utils/types'

function _sort<T = any>(
    data: T[],
    sortModel: SortingState,
    columns: GridColDefPro[],
) {
    if (!sortModel.length) return data

    let sorted = structuredClone(data)

    sorted.sort((a: any, b: any) => {
        for (const sort of sortModel) {
            const { id: field, desc } = sort,
                order = desc ? 'desc' : 'asc'
            const column = columns.find(col => col.field === field)
            if (!column) continue

            const aValue = column.valueGetter
                ? column.valueGetter({
                      row: a,
                      value: a[field],
                      id: a.id,
                      field,
                  } as any)
                : a[field]
            const bValue = column.valueGetter
                ? column.valueGetter({
                      row: b,
                      value: b[field],
                      id: b.id,
                      field,
                  } as any)
                : b[field]

            let comparison = 0
            switch (column.type) {
                case 'number':
                    comparison = Number(aValue) - Number(bValue)
                    break
                default:
                    comparison = String(aValue).localeCompare(String(bValue))
            }

            if (comparison !== 0) {
                return order === 'asc' ? comparison : -comparison
            }
        }
        return 0
    })

    return sorted
}

export default function useDefaultSortModel(columns: Array<GridColDefPro>) {
    const [sortModel, setSortModel] = useState<SortingState>([])

    const sort = <T = any>(data?: T[]) =>
        !data?.length ? ([] as T[]) : _sort(data, sortModel, columns)

    return [sortModel, setSortModel, sort] as const
}
